// src/api/tools/dataToExcel.ts

import { toExcel, type IGridColumn } from './toExcel';
import { type IWhereClause } from '../data/genericApiTypes';
import axios from 'axios';
import { basename } from '../../globals_VITE';

interface IExportDataItem {
  id: number;
  point: string;
  date: string;
  gender: string;
  age: number;
  customer_id: number;
  point_id: number;
}

const API_URL = basename + '/pcnt/v_export_vca/'; 

/**
 * Fetches data from a specified table.
 *
 * @param where Optional: Conditions for fetching data using IWhereClause.
 * todo: @param order Optional: Sorting order for the data.
 */
export const getExportData = async (where?: IWhereClause): Promise<IExportDataItem[]> => {
    const url = API_URL + (where && where.point_id ? `point/${where.point_id}/` : '');
    const res = await axios.get<IExportDataItem[]>(url, );
  return res.data;
}

interface IDataRow {
    [key: string]: string | number | boolean | null;
  }

export const dataToExcel = async (
    data: IDataRow[],
    excelFilename: string = 'export_data'    
): Promise<void> => {
    console.log(`Starting data export to Excel for ${excelFilename}`);
    try {
        // Проверяем, есть ли данные и хотя бы одна строка
        if (data && data.length > 0) {
            console.log(`Fetched ${data.length} rows. Generating columns and exporting to Excel...`);

            // Получаем первую строку для определения колонок
            const firstRow = data[0];
            // Генерируем массив IGridColumn из ключей первого объекта
            const generatedColumns: IGridColumn[] = Object.keys(firstRow).map(key => ({
                key: key, // Используем ключ объекта как key для доступа к данным
                name: key, // Используем ключ объекта как name для заголовка колонки
                // Можно добавить width или другие свойства по умолчанию, если нужно
                // width: 20,
            }));

            // Вызываем toExcel с сгенерированными колонками, данными и именем файла
            await toExcel(generatedColumns, data, excelFilename);

            console.log(`Successfully exported data to ${excelFilename}.xlsx`);
        } else {
            console.log(`No data found for export. Excel file not generated.`);
            // Можно добавить уведомление пользователю
        }
    } catch (error) {
        console.error(`Error exporting data to Excel:`, error);
        // Обработка ошибки (например, показать уведомление)
    }        
}
